import { canv } from "@/canv/global";
import { Shape } from "../shape";

export class ShapePinRight extends Shape {
    width = 200;
    height = 200;

    defaultBorderWidth = 12;
    defaultColor = "transparent";
    fillStyleEnabled = false;
    borderStyleEnabled = false;
    includeText = false;

    setDrawStyle(_: any): void {}

    draw(
        x: number,
        y: number,
        w: number,
        h: number,
        shapeStyles: {
            color: string;
            borderColor: string;
            borderDashType: string;
            borderWidth: number;
        },
    ) {
        let r = h / 50;

        if (w < 2 * r) r = w / 2;
        if (h < 2 * r) r = h / 2;

        canv.ctx.save();
        canv.ctx.strokeStyle = shapeStyles.borderColor;
        canv.ctx.lineWidth = shapeStyles.borderWidth;
        canv.ctx.fillStyle = shapeStyles.color;
        canv.ctx.beginPath();

        canv.ctx.moveTo(x + r, y);
        canv.ctx.arcTo(x + w, y, x + w, y + h, r);
        canv.ctx.arcTo(x + w, y + h, x, y + h, r);
        canv.ctx.arcTo(x, y + h, x, y, r);
        canv.ctx.arcTo(x, y, x + w, y, r);
        canv.ctx.stroke();
        canv.ctx.closePath();

        canv.ctx.beginPath();
        canv.ctx.lineCap = "round";
        canv.ctx.moveTo(x + w * 0.3, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.75, y + h * 0.5);

        canv.ctx.moveTo(x + w * 0.75, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.6, y + h * 0.3);

        canv.ctx.moveTo(x + w * 0.75, y + h * 0.5);
        canv.ctx.lineTo(x + w * 0.6, y + h * 0.7);
        canv.ctx.stroke();
        canv.ctx.closePath();
        canv.ctx.restore();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 24;
        let height = 24;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg fill="none" width="${width}" height="${height}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m6.85354 12.0207h9.09806m0 0-2.7873-3.82144m2.7873 3.82144-2.7873 4.0944m-11.1643-14.1151h20v20h-20z"
                stroke="${stroke}" fill="${fill}" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }
}
